import React, { Component } from "react";

export default class LicenseExpired extends Component {
    renderHeader = () => {
        return (
            <header className="page-layout__header header">
                <div className="header__body">
                    <div className="header__burger header__burger--desktop" />
                    <div className="header__burger header__burger--mobile" />
                    <div className="header__collapser" />
                    <div className="header__collapse">
                        <ul className="header__left-side no-bullet" />
                        <ul className="header__right-side no-bullet">
                            <li>
                                <a className="header__link header__link--exit" href="#" title="Выход">
                                    Выход
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>
        );
    };

    renderSidebar = () => {
        return (
            <aside className="page-layout__sidebar sidebar">
                <div className="sidebar__logo-wrap">
                    <span className="sidebar__logo" />
                    <div className="sidebar__close close close--md" />
                </div>
            </aside>
        );
    };

    renderModal = () => {
        return (
            <div className="modal modal--full modal--create-route modal--license-expired">
                <div className="modal__overlay" />
                <div className="modal__window modal-window modal-window--lg modal-window--license-expired">
                    <h3 className="text-center py-5">Срок лицензии истек. Пожалуйста, свяжитесь с администратором.</h3>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="page-layout">
                {this.renderHeader()}
                {this.renderSidebar()}
                <main className="page-layout__content-wrap" />
                {this.renderModal()}
                <footer className="page-layout__footer">
                    &copy; Цифровизация транспорта, {new Date().getFullYear()} год&nbsp;
                    <a href="/license-agreement" className="page-layout__license-agreement" target="_blank">
                        Лицензионный договор
                    </a>
                </footer>
            </div>
        );
    }
}
